import { Component, inject, computed } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { AlertComponent } from '@alert/feature';
import { DialogComponent } from '@shared/components/ui/dialog/feature';
import { TemporaryAuthModalComponent } from '@shared/components/ui/temporary-auth-modal';
import { ModalExpirationComponent } from '@shared/components/ui/modal-expiration';
import { SelfUserStore } from '@person/user/self/data-access';


@Component({
    selector: 'lib-presentation-ui',
    imports: [RouterOutlet, AlertComponent, DialogComponent, TemporaryAuthModalComponent, ModalExpirationComponent],
    templateUrl: './presentation-ui.component.html',
    styleUrl: './presentation-ui.component.scss'
})
export class PresentationUiComponent {
  public readonly selfUserStore = inject(SelfUserStore);
  public readonly isAdminScope = this.selfUserStore.isAdminScope();
}
